<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-table
                class="mt-2"
                striped
                hover
                :items="items"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.ITEM_PER_PAGE"
            >
                <template #cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template #cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template #cell(actions)="row">
                    <b-button
                        variant="primary"
                        class="mr-1 min-width-none"
                        @click="showUpdateModal(row.item.id)"
                        v-b-tooltip.hover
                        :title="$t('common.edit')"
                    >
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                        variant="danger"
                        @click="confirmDelete(row.item.id)"
                        v-b-tooltip.hover
                        class="min-width-none"
                        :title="$t('common.delete')"
                    >
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không có bản ghi nào</span>
                    </div>
                </template>
            </b-table>
            <div v-if="countRow > CONSTANTS.ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="countRow"
                    :per-page="CONSTANTS.ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                />
            </div>
        </div>

        <!-- Create/Edit Info -->
        <b-modal
            ref="createOrUpdateModal"
            :ok-title="`${itemInfo.id ? $t('common.update') : $t('common.create')}`"
            :title="`${itemInfo.id ? 'Cập nhật thông tin góp ý' : 'Tạo mới góp ý'}`"
            :cancel-title="$t('common.cancel')"
            @ok="handleCreateOk"
            no-close-on-esc
            no-close-on-backdrop
        >
            <b-form-group :label="$t('common.name')">
                <b-form-input
                    maxlength="255"
                    v-model="itemInfo.name"
                    :placeholder="$t('common.name')"
                />
            </b-form-group>
            <b-form-group :label="'Email'">
                <b-form-input maxlength="255" v-model="itemInfo.email" :placeholder="'Email'" />
            </b-form-group>
            <b-form-group :label="'Điện thoại'">
                <b-form-input
                    maxlength="255"
                    type="number"
                    v-model="itemInfo.phone"
                    :placeholder="'Điện thoại'"
                />
            </b-form-group>
            <b-form-group :label="'Địa chỉ'">
                <b-form-input maxlength="255" v-model="itemInfo.email" :placeholder="'Địa chỉ'" />
            </b-form-group>
            <b-form-group :label="'Nội dung'">
                <b-form-textarea
                    maxlength="255"
                    rows="5"
                    v-model="itemInfo.content"
                    :placeholder="'Nội dung'"
                />
            </b-form-group>
        </b-modal>

        <!-- Confirm Delete -->
        <b-modal
            ref="deleteModal"
            :title="$t('common.confirmation')"
            no-close-on-esc
            no-close-on-backdrop
            :ok-title="$t('common.delete')"
            :cancel-title="$t('common.cancel')"
            ok-variant="danger"
            @ok="onDelete"
            >Bạn có chắc chắn muốn xoá góp ý này?</b-modal
        >
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getList();
        });
    },
    computed: {
        ...mapState({
            items: (state) => state.feedback.items,
            item: (state) => state.feedback.item
        }),
        countRow() {
            return this.items.length;
        }
    },
    data() {
        return {
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: 'Người tạo' },
                {
                    tdClass: 'align-middle',
                    key: 'email',
                    label: 'Email'
                },
                { tdClass: 'align-middle', key: 'phone', label: 'Điện thoại' },
                { tdClass: 'align-middle', key: 'address', label: 'Địa chỉ' },
                { tdClass: 'align-middle', key: 'content', label: 'Nội dung' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                },
                {
                    thClass: 'fixed-actions-col',
                    key: 'actions',
                    label: this.$i18n.t('common.actions')
                }
            ],
            itemInfo: {},
            currentId: null,
            currentPage: 1,
            CONSTANTS
        };
    },
    methods: {
        ...mapActions({
            getList: 'feedback/getList',
            updateOrCreate: 'feedback/updateOrCreate',
            deleteById: 'feedback/delete',
            getInfo: 'feedback/getInfo'
        }),
        handleCreateOk(modal) {
            modal.preventDefault();
            this.onSubmit();
        },
        onSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.update();
                    this.$refs.createOrUpdateModal.hide();
                    this.$toaster.success('Cập nhật góp ý thành công');
                }
            });
        },
        async showUpdateModal(id) {
            this.resetForm();
            await this.getInfo({ id: id });
            this.itemInfo = { ...this.item };
            this.$refs.createOrUpdateModal.show();
        },
        async update() {
            await this.updateOrCreate(this.itemInfo);
        },
        async onDelete(modal) {
            modal.preventDefault();
            await this.deleteById({ id: this.currentId });
            if (this.items.length / this.CONSTANTS.ITEM_PER_PAGE === this.currentPage - 1) {
                this.currentPage--;
            }
            this.$refs.deleteModal.hide();
            this.$toaster.success('Xoá góp ý thành công!');
        },
        async confirmDelete(zoneId) {
            this.currentId = zoneId;
            this.$refs.deleteModal.show();
        },
        resetForm() {
            this.itemInfo = {};
        }
    }
};
</script>
